import React, { Fragment } from 'react';
import GenericButton from '../../../common/GenericButton';
import { RLD_CONFIRMATION } from '../../constants';
import { ModalContainer, RldConfirmButton } from '../../styledComponents';
import PropTypes from 'prop-types';

const RldConfirm = ({
  onContinueClicked,
  setIsRldConfirmOpen,
  isRldConfirmOpen,
}) => {
  const continueClicked = () => {
    onContinueClicked();
    setIsRldConfirmOpen(!isRldConfirmOpen);
  };
  const onCancelClicked = () => {
    setIsRldConfirmOpen(false);
  };
  return (
    <Fragment>
      <ModalContainer>
        {RLD_CONFIRMATION}
        <RldConfirmButton>
          <GenericButton name="Cancel" onBtnClick={onCancelClicked} />
          <GenericButton name="Confirm" onBtnClick={continueClicked} />
        </RldConfirmButton>
      </ModalContainer>
    </Fragment>
  );
};
RldConfirm.propTypes = {
  onContinueClicked: PropTypes.func,
  setIsRldConfirmOpen: PropTypes.func,
  isRldConfirmOpen: PropTypes.bool,
};
export default RldConfirm;
